import { CAT_CONTENT_FETCHED } from 'src/config/actions';
import getCatContent from 'src/libs/catService/getCatContent';
import { fireCatContentFetchedAction } from 'src/dispatcher';

import BaseStore from './baseStore';
import flowStore from './flowStore';

class CatContentStore extends BaseStore {
  constructor() {
    super();
    this.catContent = {};
  }

  getActiveData() {
    return this.catContent[flowStore.getActiveNodeId()];
  }

  fetchActiveData() {
    return getCatContent(flowStore.getActiveNode().learningLanguages)
      .then(fireCatContentFetchedAction);
  }

  onDispatcherAction({ type, data }) {
    switch (type) {
      case CAT_CONTENT_FETCHED:
        this.catContent[flowStore.getActiveNodeId()] = data;
        this.emitChange();
        break;
        // no default
    }
  }
}

export default new CatContentStore();
